<template>
    <div style="margin: 0 auto; min-height: 600px;">
        <div style="margin-top: 10px;">
            <span style="padding-left: 23px; font-size: 14px; color: #999999;"> 创建时间：{{ info.createTime }}</span>
        </div>
        <video  
            ref="videoPlayer"
            data-dashjs-player="" 
            :src="info.url"
            controls
            :autoplay="0"
            class="video">
        </video>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url';

    export default {
        name:'VideoPlayer',
        data() {
            return {
                url:'',
                courseVideo:{},
                info:undefined,
            }
        },
        created() {
            this.ReadProblemVideo()
        },
        mounted() {
            
            if (this.info !== undefined) {
                const videoPlayer = this.$refs.videoPlayer;
                const player = dashjs.MediaPlayer().create();

                player.initialize(videoPlayer, videoPlayer.src, true);
            }
            else {
                const t = setInterval(() => {
                    if (this.info !== undefined) {
                        const videoPlayer = this.$refs.videoPlayer;
                        const player = dashjs.MediaPlayer().create();

                        player.initialize(videoPlayer, videoPlayer.src, true);
                        clearInterval(t); // 清除定时器
                    }
                }, 100);
            }

            /* 上面别管 */
        },
        methods: {
            ReadProblemVideo(pbid) {
                const vue = this
                const store = this.$store
                const route = this.$route

                $.ajax({
                    url: Url.rProblemVideoUrl,
                    data: {
                        pbid: route.params.id,
                    },
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.info = JSON.parse(resp.list)
                            vue.isShow = true
                        } else {
                            console.log("题解视频获取失败了")
                        }
                    },
                })
            }
        }
    }
</script>

<style scoped>
.video {
    width: 96%;
    height: 48%; 
    border: 3px solid black; 
    margin-top: 20px;
    margin-left: calc(2%);
}
/* 样式 */
</style>
